export const SKIP_INTERCEPTOR = 'skip-interceptor';
export const SKIP_ORGANISATION = 'skip-organisation';